import React, { useState } from "react";
import { History, ChevronDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api, formatApiErrorDetail } from "@/lib/api";

export const DeductionHistory = () => {
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const load = async (offset = 0) => {
    setLoading(true); setError("");
    try {
      const { data } = await api.get(`/config/bend-deductions/history?offset=${offset}&limit=10`);
      setItems(old => offset ? [...old, ...data.revisions] : data.revisions); setTotal(data.total);
    } catch (e) { setError(formatApiErrorDetail(e.response?.data?.detail)); }
    finally { setLoading(false); }
  };
  return <section className="border-t pt-5" data-testid="deduction-history-section">
    <Button type="button" variant="ghost" data-testid="deduction-history-toggle" aria-expanded={open} onClick={() => { if (!open) load(); setOpen(!open); }}>
      <History size={16} className="mr-2" />Storico revisioni<ChevronDown size={14} className="ml-2" />
    </Button>
    {open && <div className="mt-4 space-y-3" data-testid="deduction-history-list">
      {error && <p role="alert" data-testid="deduction-history-error" className="text-sm text-destructive">{error}</p>}
      {!items.length && !loading && !error && <p className="text-sm text-muted-foreground" data-testid="deduction-history-empty">Nessuna revisione salvata.</p>}
      {items.map(item => <details key={item.revision} className="border-b pb-3" data-testid={`deduction-history-revision-${item.revision}`}>
        <summary className="cursor-pointer text-sm break-words" data-testid={`deduction-history-summary-${item.revision}`}>
          Rev. {item.revision} · {new Date(item.updated_at).toLocaleString("it-IT")} · {item.rows.length} righe · {item.method === "material_tabulated_deduction" ? "Ritiri per materiale" : item.method === "tabulated_deduction" ? "Ritiro tabellato" : "Regole tecniche"}
        </summary>
        <div className="grid gap-2 mt-3">
          {item.rows.map(row => <p key={row.id} className="text-xs font-mono break-words" data-testid={`deduction-history-${item.revision}-row-${row.id}`}>
            {row.family || "Generico"} · t {row.thickness_mm} mm · cava {row.cava || row.v_opening_mm} · piega {row.angle_deg}° · ritiro {row.deduction_mm} mm{row.notes ? ` · ${row.notes}` : ""}
          </p>)}
        </div>
      </details>)}
      {loading && <p role="status" data-testid="deduction-history-loading" className="text-sm">Caricamento…</p>}
      {items.length < total && <Button type="button" variant="outline" disabled={loading} data-testid="deduction-history-more" onClick={() => load(items.length)}>Revisioni precedenti</Button>}
    </div>}
  </section>;
};